import React from 'react';
import { useSelector } from 'react-redux';
import {Link, useNavigate} from 'react-router-dom';

const Profilo = () => {
    const auth = useSelector(state => state.auth)
    const configurationFile = useSelector((state) => state.configurationFile);

    const logoutARPA = React.useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        let logoutUrl = `${configurationFile.fileConf.baseUrlAuthService}/logout`;
        let redirectUrl = configurationFile.fileConf.redirectUri;
        logoutUrl += `?post_logout_redirect_uri=${encodeURIComponent(redirectUrl)}`;
        window.location.href = logoutUrl
        sessionStorage.clear()
    }, [configurationFile]);

    return (
        <div className="card card-signin animate__animated animate__fadeIn shadowCustom"
            style={{ borderRadius: '30px' }}>
            <div className="card-body text-center">
                <h3 className='card-title text-center'>
                    <i className="fa fa-user mr-2" />
                    Profilo Utente
                </h3>
                <div className="my-4">
                    <h4>{auth.user['USER_NAME']} {auth.user['USER_SURNAME']}</h4>
                    <p clasName="text-muted">({auth.user['USER_CF']})</p>
                    <p clasName="text-muted"><b>{auth.ruoloScelto.toUpperCase()}</b></p>
                    <div className="d-flex justify-content-center">
                        <Link to='/login'
                            id='buttonLogout'
                            className="col-6 px-4 mt-4 btn btn-danger shadow"
                            style={{ cursor: 'pointer' }}
                            onClick={logoutARPA}>
                            <i className="fa fa-sign-out mr-2" />
                            Esci
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Profilo;